import { render, staticRenderFns } from "./LegacyDeliveryAddressPropertyTypeField.vue?vue&type=template&id=5de35cf2&"
import script from "./LegacyDeliveryAddressPropertyTypeField.vue?vue&type=script&lang=js&"
export * from "./LegacyDeliveryAddressPropertyTypeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports